import React, { useEffect, useState } from "react";
import fnc from "../mymod/commFunction";
import { useNavigate } from "react-router-dom";
import './Assess_all_marking_stu.scss';
import { useSelector } from "react-redux";
import * as S from '../scss/theme';
import  HongButton from '../comm/HongButton';


const Assess_all_marking_stu = ({isToken}) => {
    const userInfo = useSelector((state) => state.reduxIgong.userInfo);
    const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
    const selectedTestCode = useSelector((state) => state.reduxIgong.selectedTestCode);
    const selectedStCode = useSelector((state) => state.reduxIgong.selectedStCode);

    const navigate = useNavigate();
    const [groupedList, setGroupedList] = useState([]);
    const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]); 

    useEffect(() => {
        console.log(userInfo, 'userInfo');
        console.log(selectedUserInfo, 'selectedUserInfo');
        fncQueList();
    }, []);


    function fncQueList() {

        const userKind2 = selectedUserInfo.userKind2;//학생
        let routePath;
        // if (userKind2 === '학생') {
        //     routePath = '/igonAssess_stuRoutes/select/question_stu';
        // } else {
        //     routePath = '/igonAssess_momTecRoutes/select/question_momTec';
        // }
        
        routePath = '/igonAssess_stuRoutes/select/question_stu';

        fnc.sendAxios(routePath, {}, (res) => {

            if (res && res.length > 0) {
                const processed = res.map(item => ({
                    sno: item.sno,
                    munCode: item.munCode,
                    no: item.no,
                    gpNum2: item.gpNum2,
                    gpNum1: item.gpNum1,
                    type: item.type,
                    que: item.que
                }));

                const grouped = Object.values(
                    processed.reduce((acc, item) => {
                        const key = item.gpNum2;
                        if (!acc[key]) acc[key] = [];
                        acc[key].push(item);
                        return acc;
                    }, {})
                );

                setGroupedList(grouped);
            }
        });
    }
    
    const handleSelect = (munCode, gpNum2, type, selectedSno) => {
        const newSelection = { gpNum2, type, munCode };
    
        setSelectedItems(prev => {
            const filtered = prev.filter(item => item.gpNum2 !== gpNum2);
            const updated = [...filtered, newSelection];
          
            updated.sort((a, b) => {//배열 원래대로 정렬
              const aNum = parseInt(a.munCode.replace(/\D/g, ''));
              const bNum = parseInt(b.munCode.replace(/\D/g, ''));
              return aNum - bNum;
            });
          
            return updated;
        });


          // 자동 다음 이동
          const isLast = currentGroupIndex + 1 === groupedList.length;
          // 선택 후 바로 다음 질문으로 이동 (단, 마지막 질문은 확인창 후 이동)
          if (!isLast) {
              setTimeout(() => {
                  setCurrentGroupIndex(currentGroupIndex + 1);
              }, 200); // 살짝 딜레이를 줘야 렌더 충돌 방지됨
          } else {
              setTimeout(() => {
                //   const rtn = window.confirm('진단이 완료되었습니다');
                //   // if (rtn) navigate("/nextSurvey");
                //   if (!rtn) return;
                // //   fncInsertMarking(updated);
                // //   console.log(selectedItems, 'selectedItems');
              }, 200);
          }
    
       
    };

    function handleSubmit() {

        console.log(selectedUserInfo, ' selectedUserInfo');
        const rtn = window.confirm('제출하시겠습니까??');
        if (!rtn) return;

        fncInsertMarking();
    }
    
    
    useEffect(()=> {
       console.log(selectedItems, 'selectedItems'); 
    }, [selectedItems]);


    function fncInsertMarking() {
  
        const testDate = fnc.fncDate();
        // const parentCode = selectedUserInfo.orgCode;
           const parentCode = selectedUserInfo.orgCode || selectedUserInfo.parentCode;
        const userKind = selectedUserInfo.userKind;
        const stCode = selectedUserInfo.stCode;
        // const testCode = fnc.fncSirialNum('AT');
        const testCode = selectedTestCode;
        
        const counts = { A: 0, B: 0, E: 0, F: 0 };
       
        selectedItems.forEach(item => {
            if (counts.hasOwnProperty(item.type)) {
            counts[item.type]++;
            }
        });

        const cntA = counts.A;
        const cntB = counts.B;
        const cntE = counts.E;
        const cntF = counts.F;
      
        fncInsert_marking_score(testDate, parentCode, stCode, userKind, cntA, cntB, cntE, cntF, testCode);



        function fncInsert_marking_score(testDate, parentCode, stCode, userKind, cntA, cntB, cntE, cntF, testCode) {

            fnc.sendAxios('/igonAssess_momTecRoutes/insert/assess_momTec_marking_stu', { 
                testDate, parentCode, stCode, userKind, cntA, cntB, cntE, cntF, testCode }, (res) => {
                  if (res) {
    
                    if (res.success === true) {
                        // alert('완료되었습니다.');
                        fncInsert_marking_value_total(testCode, stCode);
    
                    } else {
                    alert('저장에 실패했습니다.');
                  }
                }
            });
        }
            
    }


    function fncInsert_marking_value_total(testCode, stCode) {

        let cnt = 0;
        const tCnt = selectedItems.length;

        selectedItems.forEach((item, index) => {
            const value = item.type;
            const munCode = item.munCode;
    
                fncInsert_marking_value(testCode, stCode, munCode, value, () => {       
                    cnt ++;
                    if (cnt == tCnt) {
                        alert('완료되었습니다.'); 

                        if (isToken) {
                            navigate('/myRoomSt');    
                        } else {
                            // navigate(-1);  
                            fncGoto_assess_etc_app();  
                        }
                      
                    }
                });
    
            });

            
            function fncInsert_marking_value(testCode, stCode, munCode, value, callback) {
                fnc.sendAxios('/igonAssess_momTecRoutes/insert/assess_momTec_marking_value', { 
                    testCode, stCode, munCode, value, callback}, (res) => {
                    if (res) {
                        callback();
                    } else {
                        alert('저장에 실패했습니다.');
                    }
                });
            }
    }
  

    function fncGoto_assess_etc_app() {

        // const stCode = selectedUserInfo.stCode;
        // const testCode = selectedTestCode;

        // dispatch(setSelectedStCode(stCode));
        // dispatch(setSelectedTestCode(testCode));

        navigate('/assess_etc_app');
    }

    const handleNext = () => {
        const nextIndex = currentGroupIndex + 1;
        if (nextIndex < groupedList.length) {
            setCurrentGroupIndex(nextIndex);        
        }

    };

    const handlePrevious = () => {
        if (currentGroupIndex > 0) {
            setCurrentGroupIndex(currentGroupIndex - 1);
        }
    };

    function handleClose() {
        const rtn = window.confirm('진단평가를 취소하시겠습니까?');
        if (!rtn) return;
         navigate(-1);
    }

    const currentGroup = groupedList[currentGroupIndex];
    const gpNum2 = currentGroup?.[0]?.gpNum2;
    const selectedItem = selectedItems.find(item => item.gpNum2 === gpNum2);

    //==================================================================================
    return (
        <S.Section>
        <div className="Assess_all_marking_stu">
            <div className="wrap-main">
            <p className='heading-4 title'>{`${selectedUserInfo.userName} ${selectedUserInfo.userKind2} 코칭진단`}</p>
           
            {currentGroup && (
                <div className="question-card">
  
                    <div className="question-title">질문 {currentGroupIndex + 1}</div>

                    <div className="options">
                        {currentGroup.map(item => (
                            <div
                                key={item.sno}
                                className={`option ${selectedItem?.munCode === item.munCode ? 'selected' : ''}`}
                                onClick={() => handleSelect(item.munCode, item.gpNum2, item.type, item.sno)}
                            >
                                <span className="que-text">{item.que}</span>
                            </div>
                        ))}
                    </div>

                    <article className="nav-buttons">

                        <button className="nav-button btnClose" 
                            onClick={handleClose} >
                            취소
                        </button>

                        <button className="nav-button" 
                            onClick={handlePrevious} 
                            disabled={currentGroupIndex === 0}>
                            이전
                        </button>

                        <button
                            className={`nav-button`}
                            onClick={handleNext}
                            disabled={currentGroupIndex === groupedList.length - 1}
                            >
                            다음
                        </button>

                        <button className="nav-button btnSubmit" 
                            onClick={handleSubmit} 
                            disabled={selectedItems.length !== groupedList.length}>
                            제출
                        </button>
                    </article>
                    
                </div>
            )}

            <article className="progress-wrapper">
                <div className="progress-label">
                    {Object.keys(selectedItems).length} / {groupedList.length}
                    <span>{Math.round((Object.keys(selectedItems).length / groupedList.length) * 100)}%</span>
                </div>
                <div className="progress-bar">
                    <div
                    className="progress-fill"
                    style={{
                        width: `${(Object.keys(selectedItems).length / groupedList.length) * 100}%`
                    }}
                    />
                </div>
            </article>


            </div>
        </div>
        </S.Section>
    );
};

export default Assess_all_marking_stu;
